











































































import { fetchSolicitud } from '../fetchSolicitud';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

import { LoadingService } from '@/services/loadingService';

import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';

import {
  GridApi,
  ColumnApi,
  ColDef,
  CellContextMenuEvent,
  GridReadyEvent,
  SelectionChangedEvent,
  SelectionController,
  RowNode,
  CellClickedEvent,
  RowSelectedEvent,
  CellClassParams,
} from 'ag-grid-community';
import { differenceBy } from 'lodash';
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    DatePicker,
  },
})
export default class General extends ComponenteBaseStepper {
  @Prop({ required: true }) motivos: any[];
  permisosActuales: PermisoAccionVm[] = [];
  permisosTotales: PermisoAccionVm[] = [];
  destinosPosibles: any = [];

  findFilterList({ key }: { key: string }) {
    return this.motivos.filter(x => x[key] !== 't');
  }

  async getInformacion(): Promise<boolean> {
    let self = this;
    return fetchSolicitud(
      {
        usuario: JSON.parse(window.localStorage.user).id,
      },
      'solicitud_baja_sim_por_tarjeta/get_informacio_crear'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.formFields.numero.value = data.data.NUMERO.nuevonumero;
          this.formFields.usuario.value = data.data.USUARIO.full_name;
          this.$emit('motivo', this.formFields.motivo.value);
          return true;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return false;
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Error al cargar la información', {
          timeout: 3000,
        });
        return false;
      });
  }

  async getDatos() {
    await this.getInformacion();
  }

  reloaCantidad(data: any) {
    this.formFields.cantidad.value = data.length;
  }

  mounted() {
    this.getDatos();
  }

  rules = {
    required: (value: any) => !!value || 'Required.',
  };

  formFields: {
    numero: any;
    usuario: any;
    motivo: any;
    estado: any;
    cantidad: any;
  } = {
    numero: {
      label: 'Número',
      value: '',
    },
    usuario: {
      label: 'Usuario',
      value: '',
    },
    motivo: {
      label: 'Motivo (Obligatorio)',
      value: '',
    },
    estado: {
      label: 'Estado',
      value: 'Solicitado',
    },
    cantidad: {
      label: 'Cantidad',
      value: 0,
    },
  };

  async crearSolicitud(): Promise<boolean> {
    let self = this;
    return fetchSolicitud(
      {
        numero: this.nuevoDato.numero,
        usuario: this.nuevoDato.usuario,
        cantidad: this.nuevoDato.cantidad,
        motivo: this.nuevoDato.motivo,
      },
      'solicitud_baja_sim_por_tarjeta/crear'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(
            'Se creó la solicitud de baja SIM Nro: ' + self.nuevoDato.numero,
            { timeout: 3000 }
          );
          return true;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return false;
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Error al crear la solicitud', {
          timeout: 3000,
        });
        return false;
      });
  }

  nuevoDato: any = {};

  async CrearSolicitudes() {
    this.nuevoDato = {
      numero: this.formFields.numero.value,
      usuario: JSON.parse(window.localStorage.user).id,
      cantidad: this.formFields.cantidad.value,
      motivo: this.formFields.motivo.value,
    };
    this.$emit('nuevoDato', this.nuevoDato);
    let crear = await this.crearSolicitud();
    return crear;
  }

  // Globales
  $snotify: any;
  clienteId: number = config.getClienteSesion();
  loadingService = new LoadingService();

  //Interface
  editedItem: IFuncionalidad = {};

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
